<template>
  <div>
    <v-navigation-drawer
      dark
      color="#240087"
      width="79"
      v-model="drawer"
      fixed
      app
    >
    <v-list-item class="px-2 justify-center mt-3">
      <v-list-item-avatar class="mx-0" size="40">
        <v-img :src="user.cat_title !== 'Super User' ? require('@/assets/icon/toko.png') : require('@/assets/logo/favicon.png') "></v-img>
      </v-list-item-avatar>
    </v-list-item>

      <v-list v-for="(item, index) in menu" :key="index">
        <v-list-item class="px-1">
          <v-card
            width="70"
            height="auto"
            :color="item.link.split('/')[1] === $route.path.split('/')[1] ? '#18005A': 'transparent'"
            flat
            class="cursor-pointer ma-auto pb-2"
            :to="item.link"
          >
            <v-card-title class="justify-center pb-1 pt-3">
              <v-icon
                :color="
                  item.link.split('/')[1] === $route.path.split('/')[1]
                    ? '#ffffff'
                    : '#B2B2B2'
                "
                >{{ item.icon }}</v-icon
              >
            </v-card-title>
            <v-card-text
              class="text-center pa-0"
              style="font-size: 10px; line-height: 1.5;"
              :class="
                item.link.split('/')[1] === $route.path.split('/')[1]
                  ? 'white--text font-weight-bold'
                  : ''
              "
            >
              {{ item.label }}
            </v-card-text>
          </v-card>
          <!-- <v-divider
            vertical
            inset
            class="my-4"
            v-if="item.link.split('/')[1] === $route.path.split('/')[1]"
            style="
              border-width: 5px;
              border-color: #ffffff;
              border-radius: 25px;
              position: absolute;
              height: 40px;
              top: 1px;
              right: -5px;
            "
          >
          </v-divider> -->
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      color="#FFFFFF"
      fixed
      nav
      class="box-shadow"
      app
      style="border-radius: 0px; z-index: 9; height: 68px; ">
      <v-app-bar-nav-icon class="hidden-lg-and-up"
        @click.stop="drawer = !drawer"/>
      <!-- <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/> -->
      
      <v-toolbar-title 
        class="d-flex align-center pl-0">


        <!-- <v-chip
          :color="set_color"
          style="min-width: 120px; height: 43px; border-radius: 50px; justify-content: center">
          <span
            class="body-2 white--text mx-2"
            style="font-weight: 600;">
            {{ user.unit_title }}
          </span>
        </v-chip> -->
        <!-- <router-link to="/profile?menu=profile"> -->
        <v-list two-line class="pb-0">
            <v-list-item>
              <!-- <v-list-item-avatar class="my-1">
                <v-img :src="require('@/assets/icon/toko.png')"></v-img>
              </v-list-item-avatar> -->

              <v-list-item-content>
                <v-list-item-title>{{ user.name }} <span v-if="user.cat_title !== 'Super User'">({{ outlet_pick.outlet_name }})</span>  <v-btn 
                color="#240087"
                elevation="0"
                to="/pilih-outlet"
                v-if="user.cat_title === 'Owner'"
                x-small
                height="26"
                outlined
                class="fs-12 text-capitalize ml-2"
                style="border-radius: 7px;">Ganti Outlet</v-btn></v-list-item-title>
                <v-list-item-subtitle>{{ user.company_name }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
        </v-list>
        <!-- </router-link> -->
        
      </v-toolbar-title>

      <!-- <v-chip
        class="ma-4 white--text px-8 font-weight-medium"
        style="height: 43px; border-radius: 50px;"
        :color="set_color"
        v-if="user.cat_title !== 'Super User'"
      >
        <v-icon left>
          mdi-store
        </v-icon>

        <span
          class="body-2 white--text ml-1"
          style="font-weight: 600;">
          {{ outlet_pick.outlet_name }}
        </span>
      </v-chip> -->

      <v-spacer/>
      <div>
        <span class="blue_one cursor-pointer" @click="toLogout()">Logout</span>

      </div>

    </v-app-bar>

    <!-- <TopBar @drawer-false="drawer = false" /> -->
  </div>
</template>

<script>
// import TopBar from "@/components/TopBar.vue";
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
export default {
  // components: {
  //   TopBar,
  // },
  data() {
    return {
      drawer: true,
      detail: {},
      menu: [
        {
          label: "Beranda",
          icon: "mdi-view-dashboard",
          link: "/dashboard/general",
        },
        {
          label: "Konten",
          icon: "mdi-newspaper-variant-outline",
          link: "/content/article",
        },
        {
          label: "Konsultasi",
          icon: "mdi-chat-processing-outline",
          link: "/consultant/topic",
        },
        {
          label: "Partnership",
          icon: "mdi-charity",
          link: "/partner/account",
        },
        {
          label: "Pengaturan",
          icon: "mdi-cog-outline",
          link: "/setting/member",
        },
      ],
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    outlet_pick() {
      return this.$store.state.outlet;
    },
    token() {
      return this.$store.state.token;
    },
    // set_color() {
    //   return this.$store.state.color;
    // },
  },
  mounted() {
    let menu = [],
        menu_konfigurasi = [],
        is_konfigurasi = true,
        is_profile = true,
        menu_profile = this.$store.state.menu
    menu_profile.map((item, index) => {
      if(item.link === '/konfigurasi') {
      // if((item.sub_menu.label === 'edit profile') === false) {
      // console.log(item.sub_menu.label === 'Edit Profile')
      is_profile = item.sub_menu.filter((item) => item.label === 'Edit Profile')
        }
        })
        // console.log(item.sub_menu)
        // console.log(is_profile)
        is_profile = is_profile.length < 1 ?  false : true
    menu_profile.map((item, index) => {
      if(item.link === '/konfigurasi') {
        // }
        if(is_profile === false) {
          item.sub_menu.push(
            {
              id: 10000,
              label: "Edit Profile",
              icon: "mdi-file-cog",
              link: "/konfigurasi/profile"
            },
            {
              id: 10001,
              label: "Ganti Password",
              icon: "mdi-file-cog",
              link: "/konfigurasi/ganti-password"
            }
          )
        }
        }
    })

    this.$store.state.menu.map((item, index) => {
      menu_konfigurasi.push(item)
    })
      // console.log(item.link === '/konfigurasi')
    is_konfigurasi = this.$store.state.menu.filter((item) => item.link === '/konfigurasi')
    // console.log(is_konfigurasi)
    is_konfigurasi = is_konfigurasi.length < 1 ? false : true
    if(is_konfigurasi === false) {
      menu_profile.push(
        {
          id: 39,
          label: "Konfigurasi",
          icon: "mdi-file-cog",
          link: "/konfigurasi",
          sub_menu: [
            {
              id: 10000,
              label: "Edit Profile",
              icon: "mdi-file-cog",
              link: "/konfigurasi/profile"
            },
            {
              id: 10001,
              label: "Ganti Password",
              icon: "mdi-file-cog",
              link: "/konfigurasi/ganti-password"
            }
          ]
        }
      )
    }
    // console.log(menu_profile)
    // menu_konfigurasi.push(
    //   {
    //     id: 39,
    //     label: "Konfigurasi",
    //     icon: "mdi-file-cog",
    //     link: "/konfigurasi",
    //     sub_menu: [
    //       {
    //         id: 10000,
    //         label: "Edit Profile",
    //         icon: "mdi-file-cog",
    //         link: "/konfigurasi/profile"
    //       },
    //       {
    //         id: 10001,
    //         label: "Ganti Password",
    //         icon: "mdi-file-cog",
    //         link: "/konfigurasi/ganti-password"
    //       }
    //     ]
    //   }
    // )
    // console.log(menu_konfigurasi)
    
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      // console.log((item.link === '/konfigurasi') )
      if((item.link === '/konfigurasi') === false){
        // this.$store.state.menu = menu_konfigurasi
      } else {
        if(item.link === '/konfigurasi') {
          // item.sub_menu = menu_profile
        }
      }
    })
    // console.log(this.$store.state.menu)
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      if(((item.link).split('-').join('/')).split('/')[1] === "master") {
        // console.log(item.sub_menu)
        menu.push(item)
      }
      // return item
    })
    let menu_master = []
    this.$store.state.menu.map((item, index) => {
      // console.log((item.link).split('-').join('/'))
      if(((item.link).split('-').join('/')).split('/')[1] !== "master") {
        // console.log(item.sub_menu)
        menu_master.push(item)
      }
      // return item
    })
    let menu_with_master = menu_master
    menu_with_master.push(
      {
        label: "Master",
        icon: "mdi-cog-outline",
        link: "/menu-master"
      }
    )
    this.menu = menu.length > 0 ? menu_with_master : this.$store.state.menu

    this.fetchDetail()
  },
  methods: {
    async fetchDetail () {

      let params = {
        id: this.$store.state.outlet.outlet_id
      }

      await get(`pos/outlet/detail`, { params })
      .then(response => {
        let res = response.data

        if (res.status === 200) {
          this.detail = res.results.data
          // this.form.is_count_ppn = this.detail.is_count_ppn === '1' ? true : false
          // this.form.is_stock_displayed = this.detail.is_stock_displayed === '1' ? true : false
          // this.form.footer = this.detail.footer === null ? '' : this.detail.footer
          // this.form.logo_url = this.detail.logo_url
          let user = this.$store.state.user
          user.is_count_ppn = this.detail.is_count_ppn
          user.footer = this.detail.footer
          user.is_stock_displayed = this.detail.is_stock_displayed
          user.logo_url = this.detail.logo_url
          TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(user),
              JSON.stringify(this.$store.state.menu)
            )
            // console.log(user)

            this.$store.state.user = user
          }
      })
    },
    toLogout() {
      TokenService.removeToken()
              
      window.location = '/login'
    },
  },
  async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },
};
</script>

<style scoped>
.hover-menu:hover,
.actived {
  background: #ffe2ec !important;
}
</style>

<style scoped>
.divider-menu {
  min-height: 50px !important;
  height: 50px;
  width: 26px;
  min-width: 5px;
  margin-top: auto;
  margin-bottom: auto;
  background: #fff;
  border-radius: 10px 0px 0px 10px;
  position: relative;
  right: -11px;
}
</style>

<style>
.v-navigation-drawer__content {
  height: 100%;
  overflow-y: overlay !important;
  overflow-x: hidden;
}

/* ::-webkit-scrollbar-thumb{
  border-radius: 10px;
  background-color: #fff !important;
}
::-webkit-scrollbar {
  width: 1px;
  height: 10px;
  background-color: #fff;
} */
</style>